import { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import { FormFieldIcon } from "@insite/mobius/FormField";
import { safeColor } from "@insite/mobius/utilities";
import get from "@insite/mobius/utilities/get";
import { colorPalette } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const hoverStyle = (hover: string, selected: boolean) => css`
    &:hover {
        background: ${selected ? colorPalette.common.global.guardianBlue : hover};
        color: ${selected ? colorPalette.common.global.white : colorPalette.common.global.guardianBlue};
        text-decoration: ${selected ? "none" : "underline"};
    }
`;

const optionStyle = ({ focused, disabled, theme, selected, noHover }: any): any => {
    let background = get(theme, "colors.common.global.white");
    const colorGuardianBlue = get(theme, "colors.common.global.guardianBlue");
    const colorHover = get(theme, "colors.common.global.dynamicDropdownBgHover");
    const colorBorder = get(theme, "colors.common.global.dynamicDropdownBorder");
    const hover = safeColor(colorHover).rgb().string();

    if (disabled) {
        background = get(theme, "colors.common.accent");
    } else if (selected) {
        background = colorGuardianBlue;
    } else if (focused) {
        background = hover;
    }

    return css`
        background: ${background};
        border-bottom: solid 1px ${colorBorder};
        min-height: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        line-height: normal;
        font-size: 14px;
        font-weight: normal;
        padding-left: 12px;

        &:last-child {
            border-bottom: 0;
        }

        ${!disabled && !noHover && hoverStyle(hover, selected)};
    `;
};

export const dynamicDropdown: {
    defaultProps?: DynamicDropdownPresentationProps;
} = {
    defaultProps: {
        iconProps: {
            color: colorPalette.common.global.guardianBlue,
        },
        cssOverrides: {
            selectedText: css`
                top: 50%;
                transform: translateY(-50%);
                line-height: normal;
                font-size: 14px;
                font-weight: normal;
                padding-left: 13px;
            `,
            list: css`
                top: 100%;
                width: 100%;
            `,
            option: css`
                ${optionStyle}
            `,
            noOptions: css`
                min-height: 40px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                line-height: normal;
                font-size: 14px;
                font-weight: normal;
                padding-left: 12px;
            `,
            inputSelect: css`
                padding-left: 12px;

                &:focus {
                    padding-left: 12px;
                }

                &:disabled ~ ${FormFieldIcon} {
                    color: ${colorPalette.common.global.secondaryGray};
                }
            `,
        },
    },
};
